export enum TriggerType {
    Schedule,
    QualityIssue,
    OnlineJobCompleted,
    Alarm
}
